import React from 'react'
import Shimmer from './Shimmer'
import "./ImageSkeleton.scss"
import { FaImage } from "react-icons/fa"
const ImageSkeleton = () => {
  return (
    <div className="push">
      <div className='ImageSkeleton_Container'>
        <div className="ImageSkeleton_wrapper">
          <div className="ImageSkeleton_Img"> <FaImage /></div>
          <div className="ImageSkeleton_date"></div>
          <div className="ImageSkeleton_title"></div>
          <div className="ImageSkeletonLongText"></div>
          <div className="ImageSkeleton_time"></div>
        </div>

        <Shimmer />
      </div>
    </div>

  )
}

export default ImageSkeleton
